var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PlanList',_vm._g(_vm._b({},'PlanList',{ templates: _vm.templates, actions: _vm.actions },false),{ duplicate: _vm.duplicate }))}
var staticRenderFns = []

export { render, staticRenderFns }